import styled from 'styled-components'

export const ConfirmExitWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 1.5rem;

  h5 {
    font-size: 1.125rem;
    font-weight: 700;
    line-height: 1.75rem;
    margin-bottom: 1.25rem;
  }

  > p {
    font-size: 0.875rem;
    line-height: 1.375rem;
    &:last-of-type {
      margin-bottom: 1.25rem;
    }
  }

  .confirm-exit__info {
    width: 100%;
    //height: 4.625rem;
    padding: 0.625rem;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    background-color: ${({ theme }) => theme.colors.page.secondary};
    border: ${({ theme }) => `1px solid ${theme.colors.border.border4}`};
    margin-bottom: 0.75rem;
    margin-top: 0.75rem;
    span {
      font-size: 0.875rem;
      line-height: 1.375rem;
    }
  }

  .confirm-exit__cta {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
  }
`
